import React, { useEffect, useState } from "react";
import { Table, message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import TenantProvider from "../../../../../../shared/provider/TenantProvider";
import { TenantDto } from "../../../../../../shared/dto/TenantDto";
import columns from "./config/columns";
import customLocale from "../../../../../../shared/constants/customLocale";
import { TenantListContainer, TenantListHeader } from "./styles";
import AddEditTenant from "../AddEditTenant";
import DeleteTenant from "../DeleteTenant";
import AuthProvider from "../../../../../../shared/provider/AuthProvider";
import { SessionDto } from "../../../../../../shared/dto/SessionDto";
import { useSelection } from "../../../../../../shared/context/selection/selectionProvider";
import AlertModal from "../../../../../../shared/util/AntModal/AlertModal";

function TenantList({openAddTenant, setOpenAddTenant}: {openAddTenant: boolean, setOpenAddTenant: React.Dispatch<boolean>}): JSX.Element {
  const [tenants, setTenants] = useState<TenantDto[]>([]);
  const [selectedTenantForEdit, setSelectedTenantForEdit] = useState<TenantDto | null>(null);
  const [selectedTenantForDelete, setSelectedTenantForDelete] = useState<TenantDto | null>(null);
  const [openAddEditTenant, setOpenAddEditTenant] = useState(false);
  const [deleteTenant, setDeleteTenant] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGreetings, setShowGreetings] = useState(false);

  const { setTenantName } = useSelection();

  const tenantProvider = new TenantProvider();
  const authProvider = new AuthProvider();
  const navigate = useNavigate();

  const { tenantName } = useSelection()

  async function fetchTenants() {
    try {
      const data = await tenantProvider.getAll();
      setTenants(data);
    } catch (error) {
      message.error(
        <span>
          <b>Sessão expirada.</b> Você será redirecionado!
        </span>
      );
      setTimeout(() => navigate("/entrar"), 500);
    }
  }

  useEffect(() => {
    fetchTenants();
  }, []);

  useEffect(() => {
    if (openAddTenant) {
      setOpenAddEditTenant(true);
    }
  }, [openAddTenant]);

  useEffect(() => {
    if (!openAddEditTenant) {
      setSelectedTenantForEdit(null);
    }
  }, [openAddEditTenant]);

  useEffect(() => {
    if (!deleteTenant) {
      setSelectedTenantForDelete(null);
    }
  }, [deleteTenant]);

  useEffect(() => {
    if (openAddEditTenant || deleteTenant) {
      fetchTenants();
    }
  }, [openAddEditTenant, deleteTenant]);

  useEffect(() => {
    if (!openAddEditTenant) {
      setOpenAddTenant(false);
    }
  }, [openAddEditTenant]);

  function handleEditTenantClick(tenant: TenantDto) {
    setSelectedTenantForEdit(tenant);
    setOpenAddEditTenant(true);
  }

  function handleDeleteTenantClick(tenant: TenantDto) {
    setSelectedTenantForDelete(tenant);
    setDeleteTenant(true);
  }

  async function handleAccessTenantClick(tenant: TenantDto) {
    setLoading(true);
    try {
      const session: SessionDto = await authProvider.updateGuestTenant(tenant.tenantId);
      localStorage.setItem('tenantName', session.selectedTenantName);
      setTenantName(session.selectedTenantName);
      setShowGreetings(true);
    } catch (error) {
      message.error("Erro ao acessar tenant.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Spin spinning={loading}>
      <TenantListContainer>
        <AddEditTenant
          open={openAddEditTenant}
          setOpen={setOpenAddEditTenant}
          fetchTenants={fetchTenants}
          tenant={selectedTenantForEdit}
        />
        <DeleteTenant
          open={deleteTenant}
          setOpen={setDeleteTenant}
          tenant={selectedTenantForDelete}
          fetchTenants={fetchTenants}
        />

        <TenantListHeader></TenantListHeader>

        <Table<TenantDto>
          columns={columns(handleEditTenantClick, handleDeleteTenantClick, handleAccessTenantClick)}
          dataSource={tenants}
          locale={customLocale}
          pagination={{ defaultPageSize: 10 }}
          scroll={{ x: 920 }}
        />

        <AlertModal
          visible={showGreetings}
          onConfirm={() => setShowGreetings(false)}
          onCancel={() => setShowGreetings(false)}
          showCancelButton={false}
          title=""
          showConfirmButton={true}
        >
          <h2>Seja bem-vindo ao {tenantName}</h2>
        </AlertModal>
      </TenantListContainer>
    </Spin>
  );
}

export default TenantList;
